import { UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG } from "../../actions/QuanLyThuChiHopDong/actionTypes";

const initialState = {
  tuNgay: "01/01/2001",
  denNgay: "01/01/4000",
  ten: "",
  nhanvien: "",
  kieuvay: 0,
  loaithuchi: 0,
  tinhtrangno: -1,
  kenhthanhtoan: -1,
  hinhThucThanhToan: "-1",
  pageIndex: 1,
  pageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchQuanLyThuChiHopDong = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchQuanLyThuChiHopDong;
